import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutPageComponent } from '../about/about-page/about-page.component';
import { EsteticaMainPageComponent } from './estetica-main-page/estetica-main-page.component';

const routes: Routes = [
  {
    path: "",
    component: EsteticaMainPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TratamientosEsteticaRoutingModule { }
